import React, { useMemo, useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import TableContainer from '../../components/Common/TableContainer';
import { getmedprovider, deletemedprovider } from "service/api";
import { toast } from "react-toastify";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";

function DatatableTables({ refresh, onEdit }) {
    const[medProviderList,setMedProviderList] = useState({ providers: [] });
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState(null);

   useEffect(() => {
    fetchMedProviders();
  }, [refresh]);

    const fetchMedProviders = async () => {
        let response = await getmedprovider();
        if (response.error) {
            console.log('Error while fetching data:', response.error);      
        } else {
            setMedProviderList({ providers: response?.data?.Med_provider || [] });
        }
    }

     const openDeleteModal = (id) => {
    setSelectedDeleteId(id);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setSelectedDeleteId(null);
    setIsDeleteModalOpen(false);
  };

  const confirmDelete = async () => {
    try {
      await deletemedprovider(selectedDeleteId);
      toast.success("Medical Aid deleted successfully!");
      fetchMedProviders();
    } catch (error) {
      toast.error("Failed to delete");
      console.error("Error deleting med_provider:", error);
    } finally {
      closeDeleteModal();
    }
  };

  const columns = useMemo(
  () => [
    {
      Header: 'Medical Aid Name',
      accessor: 'med_provider',
    },
    {
      Header: "Action",
      Cell: ({ row }) => {
        const id = row.original._id;
        return (
          <>
            <button
              className="btn btn-primary btn mx-2"
              onClick={() => onEdit(row.original)}
            >
              <i className="mdi mdi-pencil"></i>
            </button>
            <button
              className="btn btn-danger mx-2"
              onClick={() => openDeleteModal(id)}
            >
              <i className="mdi mdi-trash-can font-size-15"></i>
            </button>
          </>
        );
      },
    },
  ],
  []
);

    //meta title
    document.title = "Medical Aid | List";

    return (
        // <div className="page-content">
            <div className="container-fluid mt-3">
            {/* <div className="d-flex justify-content-between align-items-center">
             <h1 className="page-title"></h1>
             <Link to="/add_ward" className="btn btn-primary">ADD NEW WARD</Link>
            </div> */}
                {/* <Breadcrumbs title="Setting" breadcrumbItem="Ward" /> */}
                <TableContainer
                        columns={columns}
                        data={medProviderList.providers}
                        isGlobalFilter={true}
                        isAddOptions={false}  
                        customPageSize={10}
                        className="custom-header-css"
                />
                <Modal isOpen={isDeleteModalOpen} toggle={closeDeleteModal} centered>
        <ModalHeader toggle={closeDeleteModal}>Confirm Deletion</ModalHeader>
        <ModalBody>
          Are you sure you want to delete this medical aid?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>Yes, Delete</Button>
          <Button color="secondary" onClick={closeDeleteModal}>Cancel</Button>
        </ModalFooter>
      </Modal>
       
            </div>
        // </div>
    );
}

export default DatatableTables;